const KEY = 'users';

export const SET_PAGE = `${KEY}/SET_PAGE`;
export const SET_FILTER_BY_TYPE = `${KEY}/SET_FILTER_BY_TYPE`;
export const SET_FILTER_BY_SEARCH = `${KEY}/SET_FILTER_BY_SEARCH`;
export const SET_IS_LOADING = `${KEY}/SET_IS_LOADING`;
export const SET_LOADING_ERROR = `${KEY}/SET_LOADING_ERROR`;
export const SET_USERS = `${KEY}/SET_USERS`;
export const SET_USERS_TOTAL = `${KEY}/SET_USERS_TOTAL`;



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUsersPage/constants.js